import {
  Car,
  Shirt,
  Droplet,
  WashingMachine,
  Beer,
  UtensilsCrossed,
  Flame,
  Wifi,
  Store,
  Lightbulb,
  Wind,
  Users
} from 'lucide-react'
import { ArenaAmenity, getAmenityLabel } from '@/types/arena'
import { H3 } from '@meiuca/ui-components'

interface AmenitiesSectionProps {
  amenities: ArenaAmenity[]
}

function getAmenityIcon(amenity: ArenaAmenity) {
  const icons = {
    [ArenaAmenity.PARKING]: Car,
    [ArenaAmenity.LOCKER_ROOM]: Shirt,
    [ArenaAmenity.SHOWER]: Droplet,
    [ArenaAmenity.BATHROOM]: WashingMachine,
    [ArenaAmenity.BAR]: Beer,
    [ArenaAmenity.RESTAURANT]: UtensilsCrossed,
    [ArenaAmenity.BBQ]: Flame,
    [ArenaAmenity.WIFI]: Wifi,
    [ArenaAmenity.STORE]: Store,
    [ArenaAmenity.LIGHTING]: Lightbulb,
    [ArenaAmenity.AIR_CONDITIONING]: Wind,
    [ArenaAmenity.BLEACHERS]: Users
  }
  return icons[amenity]
}

export function AmenitiesSection({ amenities }: AmenitiesSectionProps) {
  if (!amenities || amenities.length === 0) {
    return null
  }

  return (
    <section>
      <H3 className="mb-4">O que este local oferece</H3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {amenities.map((amenity) => {
          const Icon = getAmenityIcon(amenity)
          if (!Icon) return null

          return (
            <div
              key={amenity}
              className="flex items-center gap-3 p-3 rounded-lg border border-border-light hover:bg-background-secondary transition-colors"
            >
              <Icon className="w-5 h-5 text-brand-primary flex-shrink-0" />
              <span className="text-text-primary text-sm">{getAmenityLabel(amenity)}</span>
            </div>
          )
        })}
      </div>
    </section>
  )
}
